import { render } from "./ReportIndex.vue?vue&type=template&id=90c8a11e&ts=true"
import script from "./ReportIndex.vue?vue&type=script&lang=ts"
export * from "./ReportIndex.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/cibweb-v2-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__